import { Link } from "@inertiajs/react";

/**
 * Reusable admin stat tile. Big Fraunces number, small uppercase label,
 * palette-tinted background, optional click-through link.
 *
 * Props:
 *   icon:    React node (Lucide icon usually)
 *   label:   short uppercase label ("Pending applications")
 *   value:   the stat — string or number, rendered in Fraunces with tabular-nums
 *   color:   "primary" | "forest" | "sky" | "amber"
 *   href:    optional — wraps the tile in an Inertia Link
 */
const COLOR_CLASSES = {
  primary: "bg-primary/10 text-primary border-primary/25",
  forest:  "bg-accent/10 text-accent border-accent/25",
  sky:     "bg-info/10 text-info border-info/25",
  amber:   "bg-warning/10 text-warning-foreground border-warning/30",
};

export default function StatCard({ icon, label, value, color = "primary", href }) {
  const colorClass = COLOR_CLASSES[color] || COLOR_CLASSES.primary;
  const tile = (
    <div
      className={`rounded-xl border p-5 ${colorClass} ${
        href ? "transition-all hover:shadow-md hover:-translate-y-0.5" : ""
      }`}
    >
      <div className="flex items-center gap-2 opacity-80 mb-2">
        {icon}
        <span className="text-xs font-semibold uppercase tracking-wider">{label}</span>
      </div>
      <div className="font-display text-4xl font-semibold font-tabular leading-none">
        {value}
      </div>
    </div>
  );
  return href ? <Link href={href}>{tile}</Link> : tile;
}
